export default {
      id: "icon-plus-usage",
      viewBox: "0 0 54 54",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-plus",
      toString: function () {
        return this.url;
      }
    }